import * as React from "react";
import { DialogContent, Grid, IconButton } from "@mui/material";
import {
    Dialog,
    DialogTitle,
    DialogActions,
    Checkbox,
    FormControlLabel,
    TextField,
    Radio,
} from "@mui/material";
import { getReceiptPdc,  getSingleContract, addTransaction } from "state/apis";
import DeleteIcon from "@mui/icons-material/Delete";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { useTheme } from "@mui/material/styles";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { Close as CloseIcon } from "@mui/icons-material";

const Receipt = ({ open, onClose, onSubmit, receiptData, receiptOpenMode }) => {
    const theme = useTheme();
    const [data, setData] = React.useState([]);
    const [contractData, setContractData] = React.useState({});
    const [cashChecked, setCashChecked] = React.useState(false);
    const [chequeChecked, setChequeChecked] = React.useState(false);
    const [selectedPdcId, setSelectedPdcId] = React.useState(null);
    const [selectedPdcData, setSelectedPdcData] = React.useState(null);
    const [request, setRequest] = React.useState({
        chequeId: null,
        contractId: "",
        amount: selectedPdcData ? selectedPdcData.amount : 0,
        date: "",
        bankRefNumber: "",
        transactionType: "",
        remarks: "",
        propertyId: null,
        unitId: null,
    });
    React.useEffect(() => {
        fetchData();
        fetchContract();
    }, [receiptData, receiptOpenMode]);

    const fetchData = async () => {
        if (receiptOpenMode && receiptData) {
            try {
                const res = await getReceiptPdc(receiptData.id);
                setData(res?.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        } else {
            setData([]);
        }
    };
    const fetchContract = async () => {
        if (receiptOpenMode && receiptData) {
            try {
                const res = await getSingleContract(receiptData.id);
                setContractData((prevState) => ({
                    ...prevState,
                    ...res.contract,
                }));
                setRequest((prevState) => ({
                    ...prevState,
                    contractId: receiptData.id,
                    propertyId: receiptData.propertyId,
                    unitId: receiptData.unitId,
                }));
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        } else {
            setContractData([]);
        }
    };

    const handleCashChange = (event) => {
        const isChecked = event.target.checked;
        setCashChecked(isChecked);
        setRequest((prevState) => ({
            ...prevState,
            transactionType: "cash",
        }));
        if (isChecked) {
            setChequeChecked(false);
        }
    };

    const handleChequeChange = (event) => {
        const isChecked = event.target.checked;
        setChequeChecked(isChecked);
        setRequest((prevState) => ({
            ...prevState,
            transactionType: "cheque",
        }));
        if (isChecked) {
            setCashChecked(false);
        }
    };

    const handleSelectPdc = (pdc) => (event) => {
        const isChecked = event.target.checked;
        setSelectedPdcId(isChecked ? pdc.id : null);
        setSelectedPdcData(isChecked ? pdc : null);
        setRequest((prevValue) => ({
            ...prevValue,
            amount: isChecked ? pdc.amount : 0,
            date: isChecked ? pdc.chequeDate : "",
            contractId: isChecked ? pdc.contractId : "",
            chequeId: isChecked ? pdc.id : null,
            bankRefNumber: "",
            remarks: "",
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setRequest((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleDateChange = (date) => {
        const formattedDate = date.format("YYYY-MM-DD");
        setRequest((prevData) => ({
            ...prevData,
            date: date ? formattedDate : "",
        }));
    };

    const handleSubmit = async () => {
        try {
            if (!request?.transactionType) {
                return toast.error("Please select transaction type");
            }
            if (!request?.contractId) {
                return toast.error("Please select contract");
            }
            if (request?.transactionType === "cheque" && !request.chequeId) {
                return toast.error("Please select cheque");
            }
            if (request?.amount === 0) {
                return toast.error("Please enter amount");
            }
            const response = await addTransaction(request);
            toast.success(response.message);
            fetchData();
            fetchContract();
            setSelectedPdcId(null);
            setSelectedPdcData(null);
            setRequest((prevData) => ({
                ...prevData,
                chequeId: null,
                contractId: "",
                amount: 0,
                date: "",
                bankRefNumber: "",
                remarks: "",
                propertyId: null,
                unitId: null,
            }));
        } catch (error) {
            console.error("Error:", error);
            if (error.response) {
                toast.error(error.response.data.message);
            } else if (error.request) {
                toast.error("No response received from server.");
            } else {
                toast.error("An error occurred. Please try again.");
            }
        }
    };
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth={"md"}>
            {/* <DialogTitle sx={{ textAlign: "center", fontWeight: "900", mb: "2px" }}>
                Receipt
            </DialogTitle> */}
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    marginLeft: "6px",
                }}
            >
                Receipt
                <IconButton onClick={onClose} sx={{ color: "inherit" }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={3} p={"5px"} alignItems="center">
                    <Grid item>
                        <FormControlLabel
                            value="cash"
                            control={
                                <Radio
                                    checked={cashChecked}
                                    onChange={handleCashChange}
                                    color="primary"
                                />
                            }
                            label="Cash"
                        />
                    </Grid>
                    <Grid item>
                        <FormControlLabel
                            value="cheque"
                            control={
                                <Radio
                                    checked={chequeChecked}
                                    onChange={handleChequeChange}
                                    color="primary"
                                />
                            }
                            label="Cheque"
                        />
                    </Grid>
                </Grid>
                <TableContainer
                    sx={{ overflowX: "auto", marginBottom: theme.spacing(2), maxHeight: 900 }}
                >
                    <Table
                        stickyHeader
                        aria-label="sticky table"
                        sx={{ backgroundColor: "#fff" }}
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    fontWeight="900"
                                    sx={{
                                        backgroundColor: "#eef1f6",
                                        color: "#1a2138",
                                    }}
                                >
                                    Cheque Date
                                </TableCell>
                                <TableCell
                                    fontWeight="900"
                                    sx={{
                                        backgroundColor: "#eef1f6",
                                        color: "#1a2138",
                                    }}
                                >
                                    Cheque Number
                                </TableCell>

                                <TableCell
                                    fontWeight="900"
                                    sx={{
                                        backgroundColor: "#eef1f6",
                                        color: "#1a2138",
                                    }}
                                >
                                    Bank
                                </TableCell>
                                <TableCell
                                    fontWeight="900"
                                    sx={{
                                        backgroundColor: "#eef1f6",
                                        color: "#1a2138",
                                    }}
                                >
                                    Amount
                                </TableCell>
                                <TableCell
                                    fontWeight="900"
                                    sx={{
                                        backgroundColor: "#eef1f6",
                                        color: "#1a2138",
                                    }}
                                >
                                    Paid Amount
                                </TableCell>
                                <TableCell
                                    fontWeight="900"
                                    sx={{
                                        backgroundColor: "#eef1f6",
                                        color: "#1a2138",
                                    }}
                                >
                                    Tenant
                                </TableCell>
                                <TableCell
                                    fontWeight="900"
                                    sx={{
                                        backgroundColor: "#eef1f6",
                                        color: "#1a2138",
                                    }}
                                >
                                    Building
                                </TableCell>
                                <TableCell
                                    fontWeight="900"
                                    sx={{
                                        backgroundColor: "#eef1f6",
                                        color: "#1a2138",
                                    }}
                                >
                                    Action
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.length ? (
                                data.map((row, index) => (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                        <TableCell>
                                            {row.chequeDate
                                                ? moment(row.chequeDate).format("DD/MM/YYYY")
                                                : "-"}
                                        </TableCell>
                                        <TableCell>{row.chequeSerialNumber}</TableCell>
                                        <TableCell>{row.banks.name}</TableCell>
                                        <TableCell>{row.amount}</TableCell>
                                        <TableCell>{row.paidAmount ? row.paidAmount : 0}</TableCell>
                                        <TableCell>{contractData?.tenant?.name}</TableCell>
                                        <TableCell>{contractData?.unit?.unitNumber}</TableCell>
                                        <TableCell>
                                            <Checkbox
                                                checked={selectedPdcId === row.id}
                                                onChange={handleSelectPdc(row)}
                                                color="primary"
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell
                                        colSpan={7}
                                        sx={{ textAlign: "center", fontWeight: "700", mb: "2px" }}
                                    >
                                        No data found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                {selectedPdcData && (
                    <>
                        <TableContainer
                            sx={{
                                overflowX: "auto",
                                marginBottom: theme.spacing(2),
                                maxHeight: 900,
                            }}
                        >
                            <Table
                                stickyHeader
                                aria-label="sticky table"
                                sx={{ backgroundColor: "#fff" }}
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            fontWeight="900"
                                            sx={{
                                                backgroundColor: "#eef1f6",
                                                color: "#1a2138",
                                            }}
                                        >
                                            Cheque Date
                                        </TableCell>
                                        <TableCell
                                            fontWeight="900"
                                            sx={{
                                                backgroundColor: "#eef1f6",
                                                color: "#1a2138",
                                            }}
                                        >
                                            Cheque Number
                                        </TableCell>

                                        <TableCell
                                            fontWeight="900"
                                            sx={{
                                                backgroundColor: "#eef1f6",
                                                color: "#1a2138",
                                            }}
                                        >
                                            Bank
                                        </TableCell>
                                        <TableCell
                                            fontWeight="900"
                                            sx={{
                                                backgroundColor: "#eef1f6",
                                                color: "#1a2138",
                                            }}
                                        >
                                            Amount
                                        </TableCell>
                                        <TableCell
                                            fontWeight="900"
                                            sx={{
                                                backgroundColor: "#eef1f6",
                                                color: "#1a2138",
                                            }}
                                        >
                                            Tenant
                                        </TableCell>
                                        <TableCell
                                            fontWeight="900"
                                            sx={{
                                                backgroundColor: "#eef1f6",
                                                color: "#1a2138",
                                            }}
                                        >
                                            Building
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow
                                        // hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        key={selectedPdcData.id}
                                    >
                                        <TableCell>
                                            {selectedPdcData.chequeDate
                                                ? moment(selectedPdcData.chequeDate).format(
                                                      "DD/MM/YYYY"
                                                  )
                                                : "-"}
                                        </TableCell>
                                        <TableCell>{selectedPdcData.chequeSerialNumber}</TableCell>
                                        <TableCell>{selectedPdcData.banks.name}</TableCell>
                                        <TableCell>{selectedPdcData.amount}</TableCell>
                                        <TableCell>{contractData?.tenant?.name}</TableCell>
                                        <TableCell>{contractData?.unit?.unitNumber}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                )}
                <Grid container spacing={3} p={"5px"}>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            color="primary"
                            label="Amount"
                            type="number"
                            name="amount"
                            value={request.amount}
                            InputLabelProps={{
                                sx: { marginBottom: 1 },
                            }}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} color="primary">
                            <DatePicker
                                label="Select cheque date"
                                name="date"
                                value={request.date ? dayjs(request.date) : null}
                                onChange={handleDateChange}
                                format="DD/MM/YYYY"
                                sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused fieldset": {
                                            borderColor: "primary.main",
                                        },
                                    },
                                    "& .MuiInputLabel-root": {
                                        "&.Mui-focused": {
                                            color: "primary.main",
                                        },
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Bank Reference Number"
                            name="bankRefNumber"
                            type="number"
                            value={request?.bankRefNumber}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Remark"
                            variant="outlined"
                            multiline
                            fullWidth
                            color="primary"
                            rows={4}
                            value={request?.remarks}
                            name="remarks"
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>
                <DialogActions
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: theme.spacing(2),
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{
                            color: theme.palette.primary,
                            backgroundColor: theme.palette.primary[800],
                        }}
                    >
                        Save
                    </Button>
                    <Button
                        variant="contained"
                        // onClick={handleSubmit}
                        sx={{
                            color: theme.palette.primary.light,
                            backgroundColor: theme.palette.secondary[200],
                        }}
                    >
                        Print
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default Receipt;
